(() => {
  'use strict';

  const parse = (root, selector) => JSON.parse(root.querySelector(selector).textContent);
  const money = (amount, currency) => new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency, currencyDisplay: 'code' }).format(amount / 100);

  function init(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';

    const variants = JSON.parse(root.dataset.variants || '[]');
    const images = parse(root, '[data-sereni-counter-images]');
    const rules = parse(root, '[data-sereni-counter-quantity-rules]');
    const form = root.querySelector('.sereni-counter__form');
    const variantInput = root.querySelector('[data-variant-input]');
    const quantity = form.querySelector('[name="quantity"]');
    const add = form.querySelector('[data-add]');
    const status = root.querySelector('[data-cart-status]');
    const sticky = root.querySelector('[data-sticky]');
    const stickyAdd = root.querySelector('[data-sticky-add]');
    const stage = root.querySelector('[data-gallery-stage]');
    const stageImage = stage.querySelector('img');
    const thumbs = root.querySelector('[data-gallery-thumbs]');
    const dialog = root.querySelector('[data-gallery-dialog]');
    const dialogImage = dialog.querySelector('img');
    const zoomViewport = root.querySelector('[data-zoom-viewport]');
    const zoomToggle = root.querySelector('[data-zoom-toggle]');
    let variant = variants.find(item => String(item.id) === variantInput.value) || variants[0];
    let gallery = [];
    let imageIndex = 0;
    let submitting = false;

    const labels = () => (window.theme && window.theme.variantStrings) || {};
    const addLabel = () => variant.available ? (labels().addToCart || 'Add to cart') : (labels().soldOut || 'Sold out');
    const selectedSets = () => Math.max(Number(quantity.min) || 1, Number(quantity.value) || 1);
    const validQuantity = () => quantity.validity.valid && Number(quantity.value) > 0;
    const setText = () => `${selectedSets()} ${selectedSets() === 1 ? 'set' : 'sets'} \u00b7 ${selectedSets() * 2} stools`;
    const matchingImages = () => {
      const direct = images.filter(image => image.variantIds.includes(Number(variant.id)));
      const context = images.filter(image => image.variantIds.length === 0);
      return [...direct, ...context];
    };
    const updateButton = (button, label, total) => {
      button.disabled = submitting || !variant.available || !validQuantity();
      button.querySelector('[data-add-label],[data-sticky-label]').textContent = label;
      button.querySelector('[data-add-total],[data-sticky-total]').textContent = total;
    };
    function setImage(index) {
      imageIndex = (index + gallery.length) % gallery.length;
      const image = gallery[imageIndex];
      stageImage.src = image.src;
      stageImage.srcset = image.srcset;
      stageImage.alt = image.alt;
      root.querySelector('[data-gallery-count]').textContent = `${imageIndex + 1} / ${gallery.length}`;
      root.querySelectorAll('[data-gallery-step]').forEach(button => { button.disabled = gallery.length < 2; });
      root.querySelector('[data-gallery-caption]').textContent = image.variantIds.length ? `${variant.title}. Product photograph. Sold as a set of two.` : 'Product photograph. Sold as a set of two.';
      thumbs.querySelectorAll('button').forEach((button, buttonIndex) => button.setAttribute('aria-pressed', String(buttonIndex === imageIndex)));
    }
    function buildGallery() {
      gallery = matchingImages();
      const fragment = document.createDocumentFragment();
      gallery.forEach((image, index) => {
        const button = document.createElement('button');
        const thumbnail = document.createElement('img');
        button.type = 'button';
        button.setAttribute('aria-label', `View product photograph ${index + 1}`);
        button.setAttribute('aria-pressed', 'false');
        thumbnail.src = image.thumb; thumbnail.srcset = image.thumbSrcset; thumbnail.loading = 'lazy'; thumbnail.alt = ''; thumbnail.width = 120; thumbnail.height = 120;
        button.append(thumbnail);
        button.addEventListener('click', () => setImage(index));
        fragment.append(button);
      });
      thumbs.replaceChildren(fragment);
      setImage(0);
    }
    function applyQuantityRule() {
      const rule = rules[String(variant.id)] || { min: 1, max: null, increment: 1 };
      quantity.min = rule.min; quantity.step = rule.increment;
      if (rule.max === null) quantity.removeAttribute('max'); else quantity.max = rule.max;
      if (!quantity.validity.valid) quantity.value = rule.min;
    }
    function syncQuantity() {
      const total = validQuantity() ? money(variant.price * selectedSets(), root.dataset.currency) : '';
      const text = validQuantity() ? setText() : 'Enter a valid quantity';
      root.querySelector('[data-quantity-summary]').textContent = text;
      root.querySelector('[data-sticky-quantity]').textContent = text;
      const label = validQuantity() ? addLabel() : 'Choose quantity';
      updateButton(add, label, total); updateButton(stickyAdd, label, total);
    }
    function selectVariant(id, updateUrl) {
      const next = variants.find(item => String(item.id) === String(id));
      if (!next) return;
      variant = next; variantInput.value = next.id;
      form.querySelector('shopify-payment-terms')?.setAttribute('variant-id', String(next.id));
      root.querySelectorAll('[data-variant-id]').forEach(button => button.setAttribute('aria-pressed', String(String(button.dataset.variantId) === String(next.id))));
      root.querySelector('[data-colour-name]').textContent = next.title;
      root.querySelector('[data-sticky-colour]').textContent = next.title;
      root.querySelector('[data-price]').textContent = money(next.price, root.dataset.currency);
      const compare = root.querySelector('[data-compare-price]');
      compare.textContent = next.compare_at_price > next.price ? money(next.compare_at_price, root.dataset.currency) : '';
      compare.hidden = !(next.compare_at_price > next.price);
      applyQuantityRule(); buildGallery(); syncQuantity();
      if (updateUrl) { const url = new URL(window.location.href); url.searchParams.set('variant', next.id); window.history.replaceState({}, '', url); }
    }
    root.querySelectorAll('[data-variant-id]').forEach(button => button.addEventListener('click', () => selectVariant(button.dataset.variantId, true)));
    root.querySelectorAll('[data-gallery-step]').forEach(button => button.addEventListener('click', () => { if (gallery.length) setImage(imageIndex + Number(button.dataset.galleryStep)); }));
    root.querySelectorAll('[data-quantity-step]').forEach(button => button.addEventListener('click', () => { if (button.dataset.quantityStep === '1') quantity.stepUp(); else quantity.stepDown(); quantity.dispatchEvent(new Event('input', { bubbles: true })); }));
    quantity.addEventListener('input', syncQuantity); quantity.addEventListener('change', syncQuantity);
    stage.addEventListener('click', () => { dialogImage.src = stageImage.src; dialogImage.srcset = stageImage.srcset; dialogImage.alt = stageImage.alt; root.querySelector('[data-zoom-caption]').textContent = root.querySelector('[data-gallery-caption]').textContent; zoomViewport.classList.remove('is-zoomed'); zoomToggle.textContent = 'Zoom'; if (dialog.showModal) { sticky.hidden = true; dialog.showModal(); } });
    root.querySelector('[data-gallery-close]').addEventListener('click', () => dialog.close());
    zoomToggle.addEventListener('click', () => { const zoomed = zoomViewport.classList.toggle('is-zoomed'); zoomToggle.textContent = zoomed ? 'Fit' : 'Zoom'; zoomToggle.setAttribute('aria-label', zoomed ? 'Fit photograph to viewport' : 'Zoom to original size'); });
    async function addToCart(event) {
      event.preventDefault();
      if (submitting || !validQuantity() || !variant.available) return;
      submitting = true; status.hidden = true; syncQuantity();
      try {
        const response = await fetch(`${root.dataset.cartAddUrl.replace(/\/$/, '')}.js`, { method: 'POST', headers: { Accept: 'application/json', 'Content-Type': 'application/json' }, body: JSON.stringify({ items: [{ id: variant.id, quantity: selectedSets() }] }) });
        if (!response.ok) { const error = await response.json().catch(() => ({})); throw new Error(error.description || error.message || 'Unable to add this item to cart.'); }
        window.location.assign(root.dataset.cartUrl);
      } catch (error) { submitting = false; status.textContent = error.message; status.hidden = false; syncQuantity(); }
    }
    form.addEventListener('submit', addToCart);
    stickyAdd.addEventListener('click', () => form.requestSubmit());
    let frame = 0;
    function updateSticky() { frame = 0; const rect = add.getBoundingClientRect(); sticky.hidden = Boolean(dialog.open) || rect.top >= 0; }
    function scheduleSticky() { if (!frame) frame = requestAnimationFrame(updateSticky); }
    window.addEventListener('scroll', scheduleSticky, { passive: true }); window.addEventListener('resize', scheduleSticky, { passive: true }); dialog.addEventListener('close', scheduleSticky);
    selectVariant(variant.id, false); updateSticky();
  }

  document.querySelectorAll('.sereni-counter').forEach(init);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('.sereni-counter').forEach(init));
})();
